<template>
  <div
    class="bb-file"
    @drop.prevent
    @dragover.prevent
  >
    <component
      :is="isVersionImage && currentFiles.length > 3 ? 'VuePerfectScrollbar' : 'div'"
      :class="[
        version === 'multi-file' && !isArrayLength ? true : version && `bb-file_${version}`,
        isVersionImage && !error && 'bb-file_scroll'
      ]"
    >
      <BBFileListDefault
        :currentFiles="currentFiles"
        :version="version"
        @onDelete="onDeleteFile"
      />
      <div
        v-if="version ? version : !isArrayLength"
        :class="[
          'bb-file-upload',
          error && 'bb-file-upload_error',
          version === 'multi-file' && !isArrayLength ? true : version && `bb-file-upload_${version}`
        ]"
      >
        <label
          class="bb-file-upload__label"
          :for="`bb-upload-photo_${input.id}`"
          @dragenter="drop = true"
          @dragover="drop = true"
          @dragleave="drop = false"
          @drop="addFile($event, false)"
        >
          <div
            v-if="isVersionImage"
            v-html="ImageIcon"
          />
          <div
            v-else
            class="bb-file-upload__text"
          >
            Drag & drop or <span class="bb-file-upload__text_highlight">browse</span>
          </div>
        </label>
        <input
          v-show="false"
          :id="`bb-upload-photo_${input.id}`"
          type="file"
          :multiple="multiple"
          @change="addFile($event, true)"
        >
        <transition name="fade">
          <span
            v-if="error"
            class="bb-file-upload__error bb-error-text"
          >{{ error }}</span>
        </transition>
      </div>
    </component>
  </div>
</template>

<script>
import { get, uniqueId, map } from 'lodash'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import getFileSize from '@/mixin/getFileSize'
import { ImageIcon } from '@/constants/icon'
import BBFileListDefault from '@/components/Main/BBForm/BBFile/BBFileListDefault'

export default {
  name: 'BBFile',
  components: {
    BBFileListDefault,
    VuePerfectScrollbar
  },
  mixins: [getFileSize],
  props: ['input', 'model', 'errorText'],
  data () {
    return {
      imageIcon: ImageIcon(),
      drop: false,
      error: '',
      currentFiles: []
    }
  },
  computed: {
    version () {
      const version = get(this.input, 'version', '')
      return version
    },
    isArrayLength () {
      return this.currentFiles.length
    },
    isVersionImage () {
      const version = get(this.input, 'version', '')
      return version === 'image'
    },
    multiple () {
      const version = get(this.input, 'version', '')
      return version === 'image' || version === 'multi-file'
    }
  },
  watch: {
    errorText () {
      this.error = this.errorText
    },
    model () {
      const value = get(this.model, this.input.model, '')
      this.currentFiles = value
    }
  },
  beforeMount () {
    this.setDefaultVal()
  },
  methods: {
    toBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })
    },
    async addFile (e, isDrop) {
      this.drop = isDrop
      const newFiles = !isDrop ? get(e, 'dataTransfer.files', '') : e.target.files

      const files = await Promise.all(map(newFiles, async (file) => {
        const { name, size } = file
        file.id = uniqueId(name)
        file.label = name
        file.fileSize = this.getFileSize(size)
        file.path = await this.toBase64(file)
        return file
      }))

      this.currentFiles = [...this.currentFiles, ...files]
      this.error = false
      this.$emit('error', false)
      this.$emit('input', this.currentFiles)
      e.target.value = ''
    },
    onDeleteFile (fileId) {
      this.currentFiles = this.currentFiles.filter(({ id, _id }) => (id || _id) !== fileId)
      this.$emit('input', this.currentFiles)
    },
    setDefaultVal () {
      const value = get(this.model, this.input.model, '')
      this.currentFiles = value
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

.bb-file {
  border-radius: 5px;

  &_image {
    display: flex;
    width: 510px;
    padding: 0 0 4px 0;
  }

  &_multi-file {
    padding: 10px 10px 10px 10px;
    border-radius: 5px;
    border: 1px solid $color-mercury;
  }

  &_scroll {
    margin: 0 0 -10px 0;
  }

  &-upload {
    height: 96px;
    background: rgba($color-denim, 0.08);
    border: 1px dashed $color-denim;
    border-radius: 5px;
    position: relative;

    &_error {
      border-color: $color-pomegranate;
      background-color: rgba($color-pomegranate, 0.08); ;
    }

    &__error {
      margin: 8px 0 0 0;
    }

    &_image {
      min-height: 120px;
      min-width: 120px;
      order: 0;
      background: $color-white;
      color: $color-denim;
      margin: 0 10px 0 0;
    }

    &_multi-file {
      height: 35px;
    }

    &_hide {
      display: none;
    }

    &:hover {
      opacity: 0.8;
      transition: all .15s ease;
    }

    &__label {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      cursor: pointer;
    }

    &__text {
      font-size: 12px;
      font-weight: 600;
      color: $color-silver-deep;

      &_highlight {
        color: $color-denim;
        text-decoration: underline;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBForm/BBFile/BBFile.vue